import type { NightmareDef } from './nightmares.ts';
import type { StructureDef } from './structures.ts';

// Generated by `pnpm shapes` (tools/shapes.mjs) from the interfaces: do not edit by hand.

/*
 * Tables indexed by kind (`NIGHTMARES[e.kind].reach`) are read many times per tick, and V8 gives each mix of
 * optional fields its own shape: with two dozen of them those reads go the slow, megamorphic way. Each entry
 * is rebuilt (uniform.ts) as one literal with every field of its interface in one order (absent ones as
 * undefined), so the whole table shares one shape; a literal also keeps the object in fast mode, which
 * assigning sixty computed keys would not. Values are untouched.
 */

export const shapeNightmare = (d: NightmareDef): NightmareDef => ({
  type: d.type,
  hp: d.hp,
  speed: d.speed,
  damage: d.damage,
  reload: d.reload,
  points: d.points,
  flying: d.flying,
  ignoresTraps: d.ignoresTraps,
  pierceArmorBp: d.pierceArmorBp,
  structureHunter: d.structureHunter,
  avoidsKeep: d.avoidsKeep,
  splitCount: d.splitCount,
  splitHpBp: d.splitHpBp,
  invisible: d.invisible,
  reach: d.reach,
  deathBlast: d.deathBlast,
  burrows: d.burrows,
  siege: d.siege,
  lobs: d.lobs,
  shootsTowers: d.shootsTowers,
  group: d.group,
  perSector: d.perSector,
  shootsHeroes: d.shootsHeroes,
  huntsHeroes: d.huntsHeroes,
  mends: d.mends,
  curses: d.curses,
  knockback: d.knockback,
  roar: d.roar,
  escorted: d.escorted,
  regen: d.regen,
  shell: d.shell,
  wallBp: d.wallBp,
  structureBp: d.structureBp,
  banner: d.banner,
  raises: d.raises,
  spitsFire: d.spitsFire,
  dmgType: d.dmgType,
  resist: d.resist,
  big: d.big,
  hurls: d.hurls,
  stomp: d.stomp,
  wakes: d.wakes,
  sleeps: d.sleeps,
  weaves: d.weaves,
  poisons: d.poisons,
  brood: d.brood,
  wards: d.wards,
  breathes: d.breathes,
  tramples: d.tramples,
  spooks: d.spooks,
  bulwark: d.bulwark,
  bashes: d.bashes,
  chills: d.chills,
  freezes: d.freezes,
  brittles: d.brittles,
  calls: d.calls,
  tunnels: d.tunnels,
  glassScales: d.glassScales,
  sweeps: d.sweeps,
  plated: d.plated,
  carries: d.carries,
  dreams: d.dreams,
  blinks: d.blinks,
  preysOnWeak: d.preysOnWeak,
  unsleeping: d.unsleeping,
  stealsBoons: d.stealsBoons,
});

export const shapeStructureDef = (d: StructureDef): StructureDef => ({
  type: d.type,
  category: d.category,
  hp: d.hp,
  range: d.range,
  damage: d.damage,
  splash: d.splash,
  reload: d.reload,
  targetsGround: d.targetsGround,
  targetsAir: d.targetsAir,
  ignoresArmor: d.ignoresArmor,
  stun: d.stun,
  auraBp: d.auraBp,
  revealRange: d.revealRange,
  charges: d.charges,
  slowBp: d.slowBp,
  slowTicks: d.slowTicks,
  dotEvery: d.dotEvery,
  dotTicks: d.dotTicks,
  blocks: d.blocks,
  projectileSpeed: d.projectileSpeed,
  cost: d.cost,
  unlockLevel: d.unlockLevel,
  minEra: d.minEra,
  unique: d.unique,
  needs: d.needs,
});
